import { render, staticRenderFns } from "./ViewAttendance.vue?vue&type=template&id=564be061&scoped=true"
import script from "./ViewAttendance.vue?vue&type=script&lang=js"
export * from "./ViewAttendance.vue?vue&type=script&lang=js"
import style0 from "./ViewAttendance.vue?vue&type=style&index=0&id=564be061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564be061",
  null
  
)

export default component.exports